import _ from 'lodash';
import { ADD_LOADING, REMOVE_LOADING } from '../actions/utils';

const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADD_LOADING:
      return [...state, action.payload.id];
    case REMOVE_LOADING:
      return _.filter(state, id => id !== action.payload.id);
    default:
      return state;
  }
};
